import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagIE = function FlagIE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF9811",
    d: "M50 25c0-10.75-6.784-19.913-16.304-23.445v46.89C43.216 44.913 50 35.749 50 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#6DA544",
    d: "M0 25c0 10.749 6.784 19.913 16.304 23.445V1.555C6.784 5.087 0 14.25 0 25Z"
  }));
};
FlagIE.displayName = 'FlagIE';
export default withFlagWrapper(FlagIE);
//# sourceMappingURL=index.js.map